<template lang="pug">
// SEARCH BOX
.filter-container-mobile.sticky-tab.mobile(:class="{ active: $store.state.mobileFilterTabState }")
  // mobile filter box
  .range-slider-container.right-yellow-teeth
    .text-container
      p Let’s help you find “THE ONE”. Move the sliders to refine your search.
    .form-container(v-for="filter in filterItems")
      h3.slider-title {{ filter.name }}
      .range-slider
        MultiRangeSlider(:min="filter.minValue", :max="filter.maxValue", :enableCross="false", tooltipPlacement="bottom", tooltip="always", v-model="filter.currentValue")
      .plus-icon(v-if="filterIsMaxed(filter.currentValue[1], filter.maxValue)") +
    .button-container
      button.blue-button(@click="enableFilter") Find My LEGO Match
</template>

<script>
import MultiRangeSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    MultiRangeSlider
  },
  data () {
    return {
      searchValue: '',
      filterItems: [
        {
          name: 'AGE',
          minValue: 0,
          maxValue: 16,
          currentValue: [0, 16]
        },
        {
          name: 'PRICE',
          minValue: 0,
          maxValue: 3000,
          currentValue: [0, 3000]
        },
        {
          name: 'BRICK COUNT',
          minValue: 0,
          maxValue: 7000,
          currentValue: [0, 7000]
        }
      ]
    }
  },

  methods: {
    filterIsMaxed (currentValue, maxValue) {
      if (currentValue === maxValue) {
        return true
      } else {
        return false
      }
    },

    enableFilter () {
      if (this.$route.path.includes('themes') || this.$route.path === '/new' || this.$route.path === '/sale' || this.$route.path.includes('/search') || this.$route.path.includes('/filter')) {
        // filter item on computed level
        const priceRange = this.filterItems.find(item => item.name === 'PRICE')
        const brickcountRange = this.filterItems.find(item => item.name === 'BRICK COUNT')

        this.$store.commit('setFilterEnabledState', true)
        this.$store.commit('setFilterValueState', {
          age: [], // TODO age filter
          price: priceRange.currentValue,
          brickcount: brickcountRange.currentValue
        })

        this.$store.commit('setHomepageSidebarTab', '')
        this.$store.commit('setMobileFilterTabState', false)
      } else {
      // filter will redirect if not in themes, new, sales, search, filter
        this.$router.push(`/filter?agemin=${this.filterItems[0].currentValue[0]}&agemax=${this.filterItems[0].currentValue[1]}&pricemin=${this.filterItems[1].currentValue[0]}&pricemax=${this.filterItems[1].currentValue[1]}&brickmin=${this.filterItems[2].currentValue[0]}&brickmax=${this.filterItems[2].currentValue[1]}`)
        this.$store.commit('setMobileFilterTabState', false)
      }
    },

    searchProduct () {
      let searchParam = this.searchValue.split(' ').join('%20')
      this.searchValue = ''
      this.$router.push(`/search?value=${searchParam}`)
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../sass/_variables.sass'

// override multi range slider
.vue-slider
  height: 11px !important
  .vue-slider-rail
    border-radius: 0 !important
    background-color: white !important
    .vue-slider-process
      background-color: rgba(0, 108, 183, 0.3)
    .vue-slider-dot
      width: 30px !important
      height: 30px !important
      .vue-slider-dot-handle
        background-image: url('../assets/images/icons/brick-blue-filter.png') !important
        background-size: 100% 100%
        border-radius: 0
        background-color: transparent
        box-shadow: none
      .vue-slider-dot-tooltip-inner
        background-color: transparent !important
      .vue-slider-dot-tooltip-inner-bottom
        &::after
          display: none
      .vue-slider-dot-tooltip-text
        color: #006CB7
        font-weight: 900

.sticky-tab
  +desktop
    position: fixed !important
    top: 0

.filter-container-mobile
  z-index: 1
  background-color: #FFD500
  display: inline-flex
  padding: 20px 60px 20px 20px
  position: fixed
  align-items: center
  width: 65%
  box-sizing: border-box
  height: 257px
  z-index: 100
  margin-left: 39px
  +mobile
    flex-direction: column
    text-align: center
    width: 95%
    padding: 31px 31px 35px 60px // padding left + sidebar height
    height: 451px

.filter-container-mobile
  +mobile
    margin-left: 0
    bottom: 64px
    padding-left: 31px
    transform: translateY(200%)
    transition: 0.5s transform
  &.active
    transform: translateY(0%)

  form
    &.search
      .blue-button
        padding: 15px 30px
        background-color: #006CB7
        color: white
        border: none
        font-weight: 500
        font-size: 18px
        cursor: pointer
        width: 200px !important
        +mobile
          width: 100% !important

  .sidenav
    background-color: white
    transform: rotate(-90deg)
    position: absolute
    transform-origin: left top
    bottom: calc(0px - 45px)
    z-index: 10
    left: 0
    box-shadow: 0px 0px 1px 1px white
    width: 451px
    ul
      display: flex
      li
        text-align: center
        font-weight: 900
        font-style: italic
        color: #212121
        padding: 12px 0px
        flex: 1
        font-size: 18px
      &.filter-search
        width: 100%
        .sidebar-yellow
          background-color: $light-yellow
          box-shadow: 0px 0px 1px 1px white
          width: 128px
          cursor: pointer
          &.active
            background-color: $yellow

  .image-container
    padding-right: 10px
    img
      width: 150px

  .form-container
    width: 100%
    +mobile
      margin-top: 11.5px
    .form-field
      display: flex
      margin-top: 20px
      +mobile
        flex-direction: column
      input
        padding: 10px
        width: 100%
        font-size: 14px
        box-sizing: border-box
        margin-bottom: 0
        &::placeholder
          color: #C4C4C4
      button
        +mobile
          margin-top: 10px

.range-slider-container
  display: flex
  flex-wrap: wrap
  align-items: flex-end
  .text-container
    flex: 0 0 100%
    p
      padding-left: 9px
      margin-bottom: 30px
      +mobile
        margin-bottom: 25px
  .button-container
    flex: 1
    padding-right: 13px
    padding-left: 2px
    padding-bottom: 4px
    +mobile
      padding: 0
      margin-top: 20px
    .blue-button
      width: 100%
      padding: 15px
  .form-container
    flex: 0 0 50%
    padding: 0px 30px 30px 20px
    box-sizing: border-box
    +mobile
      flex: 0 0 100%
      padding: 0px 20px 20px 20px
    .slider-title
      margin: 0 0 0px 0
      text-align: center
    .value-range-text-container
      display: flex
      margin-top: 8px
      .min-value-container
        flex: 1
        span
          color: $blue
          display: block
          line-height: 18px
          font-size: 16px
          font-weight: 900
          transform: translateX(-8px)
          text-align: left
          +mobile
            font-size: 14px
            line-height: 16px
      .max-value-container
        span
          color: $blue
          display: block
          line-height: 18px
          font-size: 16px
          font-weight: 900
          transform: translateX(8px)
          +mobile
            font-size: 14px
            line-height: 16px
</style>
